// extracted by mini-css-extract-plugin
module.exports = {"job":"Batch_job__1YTG5","alert":"Batch_alert__2NzGY","totals":"Batch_totals__1MoKV"};